// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface ConstructionCraneIconSignature {
  Element: SVGSVGElement;
}

export const ConstructionCraneIcon: TOC<ConstructionCraneIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M24 3H21.949C21.704 1.309 20.259 0 18.5 0C16.741 0 15.296 1.309 15.051 3H2V5H5V8.172C3.836 8.584 3 9.696 3 11C3 12.654 4.346 14 6 14C7.654 14 9 12.654 9 11H7C7 11.551 6.551 12 6 12C5.449 12 5 11.551 5 11C5 10.449 5.449 10 6 10H7V5H15V24H22V7H24V3ZM0 21V15H14V21H0ZM2 17V19H12V17H2ZM17 3.5V22H20V3.5C20 2.673 19.327 2 18.5 2C17.673 2 17 2.673 17 3.5Z"/>
</svg>
</template>;